export enum RoleTypeEnum {
    Admin = 1,
    Advertiser = 2,
    Subscriber = 3,
    PosEmployee = 4,
    PublicUser = 5,
    EmployeeUser = 6,
}